import {
  GET_EQUIPMENT_SUCCESSFULL,
  GET_FILTERS_SUCCESSFUL,
  GET_LOADS_REQUEST,
  GET_DOCUMENTS_SUCCESS,
  GET_INTERESTS,
  GET_DOCUMENTS_DETAILS_SUCCESS,
  GET_LANES_SUCCESSFUL,
  GET_LOADS_DETAILS_SUCCESSFUL,
  CLEAR_SELECTED_DOCUMENT_DETAILS,
  UPDATE_SELECTED_DOCUMENT_DETAILS,
  GET_CARRIER_SUCCESSFUL,
  GET_CARRIER_DETAILS_SUCCESSFUL,
} from 'redux/actions/Loads';
import {
  BOOK_LOAD,
  GET_LOADS,
  SET_LOAD_DETAILS,
  GET_LOAD_FILTER,
  ADD_LOAD_FILTER,
  UPDATE_LOAD_FILTER,
} from '../../@jumbo/constants/ActionTypes';

const INIT_STATE = {
  loads: [],
  filters: [],
  totalFilters: 0,
  journeys: [],
  documents: [],
  documentDetails: {},
  totalLoads: 0,
  currentLoad: null,
  equipments: [],
  interests: [],
  lanes: [],
  loadsDetails: {},
  carriers: [],
  carrierDetails: {}
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LOADS_REQUEST: {
      return {
        ...state,
      };
    }
    case GET_LOADS: {
      return {
        ...state,
        loads: action.payload && action.payload.loads,
        totalLoads: action.payload && action.payload.total_count,
      };
    }
    case GET_FILTERS_SUCCESSFUL: {
      return {
        ...state,
        filters: action.payload && action.payload.loadsFilters,
        totalFilters: action.payload && action.payload.total_count,
      };
    }
    case SET_LOAD_DETAILS: {
      return {
        ...state,
        currentLoad: action.payload,
      };
    }
    case BOOK_LOAD: {
      return {
        ...state,
        loads: state.loads.map(load => (load.id === action.payload.id ? action.payload : load)),
      };
    }
    case GET_LOAD_FILTER: {
      return {
        ...state,
        currentLoadFilter: action.payload,
      };
    }
    case ADD_LOAD_FILTER: {
      return {
        ...state,
        currentLoadFilter: action.payload,
      };
    }
    case UPDATE_LOAD_FILTER: {
      return {
        ...state,
        currentLoadFilter: action.payload,
      };
    }
    case GET_DOCUMENTS_SUCCESS: {
      return {
        ...state,
        documents: action.resetRedux ?
         [...action.payload.dispatches] :
         [...state.documents, ...action.payload.dispatches],
      };
    }
    case GET_DOCUMENTS_DETAILS_SUCCESS: {
      return {
        ...state,
        documentDetails: action.payload,
      };
    }
    case GET_EQUIPMENT_SUCCESSFULL: {
      return {
        ...state,
        equipments: action.payload,
      };
    }
    case GET_INTERESTS: {
      return {
        ...state,
        interests: action.payload && action.payload.interests,
        totalInterests: action.payload && action.payload.total_count,
      };
    }
    case GET_LANES_SUCCESSFUL: {
      return {
        ...state,
        lanes: action.payload
      }
    }
    case GET_CARRIER_SUCCESSFUL: {
      return {
        ...state,
        carriers: action.payload
      }
    }
    case GET_CARRIER_DETAILS_SUCCESSFUL: {
      return {
        ...state,
        carrierDetails: action.payload
      }
    }
    case GET_LOADS_DETAILS_SUCCESSFUL: {
      return {
        ...state,
        loadsDetails: action.payload
      }
    }
    case CLEAR_SELECTED_DOCUMENT_DETAILS: {
      return {
        ...state,
        documentDetails: {}
      }
    }
    case UPDATE_SELECTED_DOCUMENT_DETAILS: {
      return {
        ...state,
        documentDetails: action.payload
      }
    }
    default:
      return state;
  }
};
